/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.LanternStartComponent, {
    bg: {
        scale9: {
            width: 590,
            height: 290
        }
    },
    lanternIcon: {
        x: { align: "center", dx: -140 },
        y: { align: "center" }
    },

    helpButton: {
        x: { align: "right", dx: -6 },
        y: { align: "top", dy: -6 },
        scale: 1
    },

    label: {
        x: { align: "center", dx: 100 },
        y: { align: "center", dy: 65 }
    },

    progressBar: {
        x: { align: "center", dx: 100 }
    }
});
